/* ModaConcrete — paver add-ons in cart:
   - GUARD: auto-remove any add-on that has no parent paver (never buyable alone).
   - DISPLAY: collapse a group's add-ons into a tidy summary on the parent line,
     each add-on showing its coverage (qty) on one side and price on the other.
   Race-proof + fail-safe (wrapped in try/catch so the cart can never break). */
(function () {
  'use strict';
  var GROUP = '_group';
  var APPLIES = 'Applies to';
  var COVERAGE = 'Coverage';
  var ADDON_PRODUCT_IDS = [8790298787993, 8790298853529]; // Penetrating Sealer, Bush-Hammered Finish
  var observers = [];
  var targets = [];
  var busy = false;
  var dirty = false;
  var timer = null;
  var guarding = false;

  function money(c) { return '$' + (((c == null ? 0 : c)) / 100).toFixed(2); }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function containers() {
    var out = [];
    var d = document.querySelector('#CartDrawer-CartItems .drawer__cart-items-wrapper');
    if (d) out.push(d);
    var p = document.querySelector('#main-cart-items table.cart-items tbody');
    if (p) out.push(p);
    return out;
  }

  function rowsOf(c) {
    return Array.prototype.slice.call(c.children).filter(function (n) {
      return n.classList && n.classList.contains('cart-item');
    });
  }

  function buildGroups(cart) {
    var groups = {};
    cart.items.forEach(function (it, i) {
      var p = it.properties || {};
      var g = p[GROUP];
      if (!g) return;
      if (!groups[g]) groups[g] = { parent: null, addons: [] };
      if (p[APPLIES]) groups[g].addons.push(i);
      else groups[g].parent = i;
    });
    return groups;
  }

  /* GUARD — returns true if it removed orphan add-ons (and triggered a reload) */
  function enforceParents(cart, groups) {
    if (guarding) return true;
    var orphanKeys = [];
    cart.items.forEach(function (it) {
      if (ADDON_PRODUCT_IDS.indexOf(it.product_id) === -1) return;
      var p = it.properties || {};
      var g = p[GROUP];
      var hasParent = g && groups[g] && groups[g].parent !== null;
      if (!hasParent) orphanKeys.push(it.key);
    });
    if (!orphanKeys.length) return false;
    guarding = true;
    var updates = {};
    orphanKeys.forEach(function (k) { updates[k] = 0; });
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () { window.location.reload(); })
      .catch(function () { guarding = false; });
    return true;
  }

  function lockQty(el, item) {
    var q = el.querySelector('quantity-input');
    if (!q || q.dataset.mcLocked) return;
    q.dataset.mcLocked = '1';
    q.style.display = 'none';
    var s = document.createElement('div');
    s.className = 'mc-qty-static';
    s.textContent = item.quantity + ' pcs';
    q.parentNode.insertBefore(s, q);
  }

  function addEditLink(pEl, item) {
    if (pEl.querySelector('.mc-edit-link')) return;
    var nameEl = pEl.querySelector('.cart-item__name');
    if (!nameEl) return;
    var a = document.createElement('a');
    a.className = 'mc-edit-link';
    a.href = item.url || '#';
    a.textContent = 'Edit configuration';
    if (nameEl.parentNode) nameEl.parentNode.insertBefore(a, nameEl.nextSibling);
  }

  function injectSummary(pEl, cart, addonIdxs) {
    if (pEl.dataset.mcSummary) return;
    var dl = pEl.querySelector('dl');
    if (!dl) { pEl.dataset.mcSummary = '1'; return; }

    Array.prototype.slice.call(dl.querySelectorAll('.product-option')).forEach(function (po) {
      var dt = po.querySelector('dt');
      if (dt && dt.textContent.toLowerCase().indexOf('add-on') > -1) po.remove();
    });

    var coverageEl = null;
    Array.prototype.slice.call(dl.querySelectorAll('.product-option')).forEach(function (po) {
      var dt = po.querySelector('dt');
      if (dt && dt.textContent.toLowerCase().indexOf('coverage') > -1) coverageEl = po;
    });

    var block = document.createElement('div');
    block.className = 'mc-addons-list';
    var label = document.createElement('span');
    label.className = 'mc-addons-list__label';
    label.textContent = 'Add-ons';
    block.appendChild(label);

    addonIdxs.forEach(function (ai) {
      var it = cart.items[ai];
      if (!it) return;
      var name = (it.product_title || it.title || 'Add-on').split(' (per sq ft)').join('');
      var price = money(it.final_line_price != null ? it.final_line_price : it.line_price);
      var cov = (it.properties && it.properties[COVERAGE]) ? it.properties[COVERAGE] : (it.quantity + ' sq ft');
      var line = document.createElement('span');
      line.className = 'mc-addon-line';
      line.innerHTML = '<span class="mc-addon-line__name">+ ' + name + '</span>'
        + '<span class="mc-addon-line__qty">' + cov + '</span>'
        + '<span class="mc-addon-line__price">' + price + '</span>';
      block.appendChild(line);
    });

    if (coverageEl && coverageEl.parentNode) coverageEl.parentNode.insertBefore(block, coverageEl.nextSibling);
    else dl.appendChild(block);
    pEl.dataset.mcSummary = '1';
  }

  function cascadeRemove(pEl, cart, parentIdx, addonIdxs) {
    var btn = pEl.querySelector('cart-remove-button button, cart-remove-button a');
    if (!btn || pEl.dataset.mcRemoveHooked) return;
    pEl.dataset.mcRemoveHooked = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var updates = {};
      try {
        updates[cart.items[parentIdx].key] = 0;
        addonIdxs.forEach(function (ai) { updates[cart.items[ai].key] = 0; });
      } catch (err) {}
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }, true);
  }

  function display(cart, groups) {
    containers().forEach(function (c) {
      var els = rowsOf(c);
      if (els.length !== cart.items.length) return;
      Object.keys(groups).forEach(function (g) {
        var grp = groups[g];
        if (grp.parent === null) return;
        var pEl = els[grp.parent];
        if (!pEl) return;
        pEl.classList.add('mc-parent');
        grp.addons.forEach(function (ai) { var el = els[ai]; if (el) el.classList.add('mc-addon-hidden'); });
        injectSummary(pEl, cart, grp.addons);
        lockQty(pEl, cart.items[grp.parent]);
        addEditLink(pEl, cart.items[grp.parent]);
        cascadeRemove(pEl, cart, grp.parent, grp.addons);
      });
    });
  }

  function process(cart) {
    if (!cart || !cart.items || !cart.items.length) return;
    var groups = buildGroups(cart);
    if (enforceParents(cart, groups)) return; // orphan add-ons removed -> reloading
    display(cart, groups);
  }

  function reconnectAll() {
    observers.forEach(function (o, i) {
      if (targets[i]) o.observe(targets[i], { childList: true, subtree: true });
    });
  }

  function actuallyRun() {
    if (busy) { dirty = true; return; }
    busy = true;
    getCart().then(function (cart) {
      observers.forEach(function (o) { o.disconnect(); });
      try { process(cart); } catch (e) {}
      reconnectAll();
      busy = false;
      if (dirty) { dirty = false; run(); }
    });
  }

  function run() {
    clearTimeout(timer);
    timer = setTimeout(actuallyRun, 120);
  }

  function init() {
    try {
      ['#CartDrawer-CartItems', '#main-cart-items'].forEach(function (sel) {
        var node = document.querySelector(sel);
        if (!node) return;
        targets.push(node);
        var obs = new MutationObserver(function () { run(); });
        observers.push(obs);
        obs.observe(node, { childList: true, subtree: true });
      });
      document.addEventListener('cart:change', run);
      document.addEventListener('cart:refresh', run);
      document.addEventListener('cart:updated', run);
      run();
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();